import { Link } from "react-router-dom";
import { ReactComponent as CalendarEmptyIllustration } from "../../../media/calendar_empty.svg";
import "../../../styles/Containers.css";

// Same illustrated empty-state language as the grocery tab: one component,
// content swapped per variant. "empty" is embedded in the calendar's own
// chrome (week header/nav from Calendarr.js); "guest" is wrapped with its
// own header/Navbar by Calendarr.js since there's no week to show at all.
const COPY = {
  guest: {
    title: "تقویم غذاییت اینجا منتظرته",
    caption: "وارد حسابت شو تا غذاهات رو برنامه‌ریزی کنی و همیشه بدونی امروز چی می‌پزی.",
    ctaTo: "/login",
    ctaLabel: "ورود یا ثبت‌نام",
  },
  empty: {
    title: "این هفته هنوز غذایی برنامه‌ریزی نکردی",
    caption: "از بین صدها دستور غذا انتخاب کن و به تقویمت اضافه‌شون کن.",
    ctaTo: "/cards",
    ctaLabel: "دیدن غذاها",
  },
};

function CalendarEmptyState({ variant = "empty", onAddFood }) {
  const copy = COPY[variant] || COPY.empty;

  return (
    <div className="centerd centerAlign paddingTop5 marginBottom5">
      <CalendarEmptyIllustration
        role="img"
        aria-label="یک برگه تقویم خالی با یک نشان سبز"
      />
      <p className="heading-3 grey-1 marginTop5">{copy.title}</p>
      <p className="subject-2 yekan grey-2 marginTop1 marginBottom5 paddingSide10">
        {copy.caption}
      </p>
      <Link to={copy.ctaTo} className="primaryPurple">
        {copy.ctaLabel}
      </Link>
      {onAddFood && (
        <button type="button" className="calAddCustomLink yekan" onClick={onAddFood}>
          یا غذای دلخواهت رو مستقیم اضافه کن
        </button>
      )}
    </div>
  );
}

export default CalendarEmptyState;
